import { apiPaths } from '@core/http/apiPaths';
import { httpClient } from '@core/http/httpClient';
import { EntityReducers } from '@core/store/EntityReducers';
import { getPathPayload } from '@hwm/ui-lib';
import { LeakTableModel, LeakDetailsModel } from '@models/ILeak';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

export interface IGetLeaksParams {
  accountId: string;
}

const getAllLeaks = createAsyncThunk(`${EntityReducers.leaks}/getAll`, async (payload: IGetLeaksParams) => {
  const response: AxiosResponse<LeakTableModel[]> = await httpClient.get(
    apiPaths.accounts.getLeaks({ accountId: payload.accountId })
  );

  return response.data;
});

const getLeak = createAsyncThunk(
  `${EntityReducers.leaks}/get`,
  async (payload: getPathPayload<typeof apiPaths.leaks.leakConfirmation>) => {
    const response: AxiosResponse<LeakDetailsModel> = await httpClient.get(apiPaths.leaks.leakConfirmation(payload));

    return response.data;
  }
);

interface CreateUpdateLeakThunkParams extends LeakDetailsModel {
  accountId: number;
}

const createLeak = createAsyncThunk(
  `${EntityReducers.leaks}/add`,
  async (payload: CreateUpdateLeakThunkParams, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response: AxiosResponse = await httpClient.post(apiPaths.leaks.createLeakConfirmation, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const updateLeak = createAsyncThunk(
  `${EntityReducers.leaks}/update`,
  async (payload: CreateUpdateLeakThunkParams, { rejectWithValue }) => {
    if (!payload.id) return;

    try {
      const response: AxiosResponse = await httpClient.put(
        apiPaths.leaks.updateLeakConfirmation({
          leakId: payload.id.toString(),
        }),
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const thunks = {
  getAllLeaks,
  getLeak,
  createLeak,
  updateLeak,
};
